/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbAdmissionCoordinatorSummary } from './HchbAdmissionCoordinatorSummary';
import {
    HchbAdmissionCoordinatorSummaryFromJSON,
    HchbAdmissionCoordinatorSummaryFromJSONTyped,
    HchbAdmissionCoordinatorSummaryToJSON,
    HchbAdmissionCoordinatorSummaryToJSONTyped,
} from './HchbAdmissionCoordinatorSummary';

/**
 * 
 * @export
 * @interface HchbAdmissionCoordinatorPage
 */
export interface HchbAdmissionCoordinatorPage {
    /**
     * 
     */
    data: Array<HchbAdmissionCoordinatorSummary>;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the HchbAdmissionCoordinatorPage interface.
 */
export function instanceOfHchbAdmissionCoordinatorPage(value: object): value is HchbAdmissionCoordinatorPage {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function HchbAdmissionCoordinatorPageFromJSON(json: any): HchbAdmissionCoordinatorPage {
    return HchbAdmissionCoordinatorPageFromJSONTyped(json, false);
}

export function HchbAdmissionCoordinatorPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbAdmissionCoordinatorPage {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbAdmissionCoordinatorSummaryFromJSON)),
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'has_next': json['has_next'],
    };
}

export function HchbAdmissionCoordinatorPageToJSON(json: any): HchbAdmissionCoordinatorPage {
    return HchbAdmissionCoordinatorPageToJSONTyped(json, false);
}

export function HchbAdmissionCoordinatorPageToJSONTyped(value?: HchbAdmissionCoordinatorPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(HchbAdmissionCoordinatorSummaryToJSON)),
        'page': value['page'],
        'limit': value['limit'],
        'total': value['total'],
        'has_next': value['has_next'],
    };
}

